import React from 'react';
import './App.css';
import { ContentWrapper } from './components/wrappers/ContentWrapper.component';

function App() {
  return (
    <ContentWrapper />
  );
}

export default App;
